import * as runtime from '../../runtime';
import { IInitializeServiceOptions } from '../../types';
import { CloudshellConfigResponse, UserProducts } from './models';

export class IICsCloudShellService extends runtime.BaseAPI {
	constructor(
		configuration: runtime.Configuration,
		private tenantId: string,
	) {
		super(configuration);
	}

	async getConfigRaw(): Promise<runtime.ApiResponse<CloudshellConfigResponse>> {
		const queryParameters: runtime.HTTPQuery = {};
		const headerParameters: runtime.HTTPHeaders = {};
		const response = await this.request({
			path: '/config',
			method: 'GET',
			headers: headerParameters,
			query: queryParameters,
		});

		return new runtime.JSONApiResponse(response);
	}

	async getConfig(): Promise<CloudshellConfigResponse> {
		const response = await this.getConfigRaw();
		return response.value();
	}

	async getProductsRaw(): Promise<runtime.ApiResponse<UserProducts>> {
		const queryParameters: runtime.HTTPQuery = {};
		const headerParameters: runtime.HTTPHeaders = {};
		const response = await this.request({
			path: '/api/v1/UserProductsInfo',
			method: 'GET',
			headers: headerParameters,
			query: queryParameters,
		});

		return new runtime.JSONApiResponse(response);
	}

	async getProducts(): Promise<UserProducts> {
		const response = await this.getProductsRaw();
		return response.value();
	}
}

export const initializeCloudShellService = ({ fetchApi, serviceBaseURLs, tenantId }: Required<IInitializeServiceOptions>) => {
	const cloudShellService = new IICsCloudShellService(
		new runtime.Configuration({
			fetchApi,
			basePath: serviceBaseURLs.cloudShell,
		}),
		tenantId,
	);

	return cloudShellService;
};
